import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useLanguage } from '@/contexts/LanguageContext';

export const TrainingTools = () => {
  const { t, language } = useLanguage();

  const tools = language === 'fr' ? [
    'IA générative', 'Recherche juridique', 'Analyse documentaire', 'Drafting automatisé', 'Prompt engineering', 'Veille réglementaire', 'Due diligence', 'Analyse de risques', 'Conformité RGPD'
  ] : [
    'Generative AI', 'Legal research', 'Document analysis', 'Automated drafting', 'Prompt engineering', 'Regulatory watch', 'Due diligence', 'Risk analysis', 'GDPR compliance'
  ];

  return (
    <section className="py-16 bg-white border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-foreground mb-8 text-center">
          {t('toolsTitle')}
        </h2>
        <div className="flex flex-wrap justify-center gap-4">
          {tools.map((tool) => (
            <Badge key={tool} variant="secondary" className="text-base px-4 py-2 bg-secondary hover:bg-secondary/80">
              {tool}
            </Badge>
          ))}
        </div>
      </div>
    </section>
  );
};
